import React from 'react'
import renderInputField from 'components/FormControls/textInput'

import { useTranslation } from 'react-i18next'
import { Field } from 'redux-form'
import TaxNumberField from 'modules/Forms/Finance/PaymentProfileCreate/subcomponents/TaxNumberField'
import renderMaskedInput from 'components/FormControls/maskedInputField'
import phoneFieldNormalize from 'utils/normalize/phoneFieldNormalize'
import phoneMask from 'utils/constants/phoneMask'
import PropTypes from 'prop-types'

const PersonalForeign = ({ form }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.last_name"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.last_name.label')}
          t={t}
        />
      </div>
      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.first_name"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.first_name.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <TaxNumberField
          form={form}
          label={t('payment_profiles::new.fields.details.tax_number.label_not_ru')}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          normalize={phoneFieldNormalize}
          name="details.phone"
          component={renderMaskedInput}
          placeholderChar={'\u2002'}
          placeholder={'+ ( )'}
          mask={phoneMask}
          label={t('payment_profiles::new.fields.details.phone.label')}
          t={t}
        />
      </div>
    </>
  )
}

export default PersonalForeign

PersonalForeign.propTypes = {
  form: PropTypes.string,
}
